import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-bulb',
  templateUrl: './icon-bulb.component.html',
  styleUrls: ['./icon-bulb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconBulbComponent {
  @Input() active = false;

  constructor() {}
}
